export default "__VITE_ASSET__CkfzWvHH__"